import "./Footer.css";
import awardIcon from "../../../assets/Antonio-Meucci.jpg";
import awardIcon2 from "../../../assets/mvno-nation.jpg";
import logoGb from "../../../assets/logo-gb.png";

import fbIcon from "../../../assets/social/facebook.png";
import instIcon from "../../../assets/social/inst.png";
import tiktokIcon from "../../../assets/social/tik-tok.png";
import twitterIcon from "../../../assets/social/twitter.png";

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner">
        {/* 1) Logo + nazwa */}
        <section className="footer__col footer__brand">
          <h3 className="section__title">Telviora</h3>
          {/* <img className="footer__logo" src={logoGb} alt="Globtel GmbH" /> */}

          <p className="footer__tagline">Global Travel Connectivity</p>

          <h3 className="section__title">Legal</h3>

          <a href="/terms" className="footer__privacy-link">
            Terms and Conditions
          </a>
          <a href="/privacy-policy" className="footer__privacy-link">
            Privacy Policy
          </a>
        </section>

        {/* 2) Adresy */}
        <section className="footer__col footer__offices" aria-label="Offices">
          <h3 className="section__title">Get in touch</h3>
          <div className="offices__grid">
            <div className="office">
              {/* <h5 className="office__title">Office in Latvia</h5> */}
              <p className="office__addr">
                Telviora by Mobile World DWC LLC
                <br />
                <br />
                Dubai South, Dubai, UAE
              </p>
              <p className="office__phone">contact@telviora.com</p>

              <div className="social-row">
                <a
                  className="social__link"
                  href="https://www.instagram.com/telviora.esimdata"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <img src={instIcon} alt="" className="social__icon" />
                </a>

                <a
                  className="social__link"
                  href="https://www.twitter.com/telviora"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X"
                >
                  <img src={twitterIcon} alt="" className="social__icon" />
                </a>

                <a
                  className="social__link"
                  href="https://www.tiktok.com/@telviora.esim.dat"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TikTok"
                >
                  <img src={tiktokIcon} alt="" className="social__icon" />
                </a>

                <a
                  className="social__link"
                  href="https://www.facebook.com/Telviora"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <img src={fbIcon} alt="" className="social__icon" />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* 3) Nagrody – lista pionowa: ikona + link + data */}
        {/* <section className="footer__col footer__awards" aria-label="Awards">
          <h3 className="section__title">Latest news</h3>
          <article className="award-item">
            <img className="award__icon" src={awardIcon} alt="" aria-hidden="true" />
            <div className="award__body">
              <a
                className="award__link"
                href="https://globtel.de/uncategorized/success-on-antonio-meucci-awards-2024/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Success on Antonio Meucci Awards 2024
              </a>
              <time className="award__date" dateTime="2024-10-07">
                October 7, 2024
              </time>
            </div>
          </article>
          <article className="award-item">
            <img className="award__icon" src={awardIcon2} alt="" aria-hidden="true" />
            <div className="award__body">
              <a
                className="award__link"
                href="https://globtel.de/uncategorized/mvno-nation-event-in-valencia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MVNO Nation Event in Valencia
              </a>
              <time className="award__date" dateTime="2023-06-23">
                June 23, 2023
              </time>
            </div>
          </article>
        </section> */}
      </div>

      <div className="footer__bar">
        <small>© {new Date().getFullYear()} Telviora. All rights reserved.</small>
      </div>
    </footer>
  );
}
